import toast from 'react-hot-toast';
import { takeEvery, put, call, select } from 'redux-saga/effects';
import * as showcaseApi from '../../api/showcaseApi';
import * as actions from '../actions';
import * as selectors from '../selectors';
import { getUserOrWait } from './sagaUtils';

export function* getFirms() {
  try {
    yield put(actions.firm.getFirmsForLookup());
    const user = yield getUserOrWait();
    const isGowUser = yield select(selectors.users.isGowUser);
    yield put(actions.user.setLoading(true));
    let firms = yield call(showcaseApi.getFirms);

    if (!isGowUser) {
      const isFirmForUser = firm => firm.id === user.userGroupId;
      firms = firms.filter(isFirmForUser);
    }

    yield put(actions.firm.getFirmsSuccess(firms));
  } catch (e) {
    yield put(actions.firm.getFirmsFail(e.message));
    toast.error('An error occurred getting firms.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* getFirmsForLookup() {
  try {
    const user = yield getUserOrWait();
    const isGowUser = yield select(selectors.users.isGowUser);
    yield put(actions.user.setLoading(true));
    let firms = yield call(showcaseApi.getFirmsForLookup);
    console.log({ firms });

    if (!isGowUser) {
      const isFirmForUser = firm => firm.userGroupId === user.userGroupId;
      firms = firms.filter(isFirmForUser);
      console.log('after filter', { firms });
    }

    yield put(actions.firm.getFirmsForLookupSuccess(firms));
  } catch (e) {
    yield put(actions.firm.getFirmsForLookupFail(e.message));
    toast.error('An error occurred getting firms.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* getFirmById({ payload: { id } }) {
  try {
    if (!id) {
      return;
    }
    yield put(actions.user.setLoading(true));
    const firm = yield call(showcaseApi.getFirmById, { id });
    yield put(actions.firm.getFirmByIdSuccess(firm));
  } catch (e) {
    yield put(actions.firm.getFirmByIdFail(e.message));
    toast.error('An error occurred getting firm.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* addFirm({ payload: { firm } }) {
  try {
    yield put(actions.user.setLoading(true));
    const _firm = yield call(showcaseApi.addFirm, firm);
    yield put(actions.firm.addFirmSuccess(_firm));
    yield put(actions.firm.getFirms());
    toast.success('Firm created.');
  } catch (e) {
    yield put(actions.firm.addFirmFail(e.message));
    toast.error('An error occurred creating the firm.  Make sure a firm with the same name does not already exist.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* updateFirm({ payload: { firm } }) {
  try {
    yield put(actions.user.setLoading(true));
    const _firm = yield call(showcaseApi.updateFirm, firm);
    yield put(actions.firm.updateFirmSuccess(_firm));
    yield put(actions.firm.getFirmById(firm.id));
    yield put(actions.firm.getFirms());
    toast.success('Firm updated.');
  } catch (e) {
    yield put(actions.firm.updateFirmFail(e.message));
    toast.error(
      'An error occurred updating the firm.  Make sure you did not rename the firm to a name that is already in use.'
    );
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* addFirmToOrganization({ payload: { firmId } }) {
  try {
    yield put(actions.user.setLoading(true));
    const organization = yield select(selectors.getCurrentGroup);
    yield call(showcaseApi.addFirmToOrganization, { firmId, userGroupId: organization.id });
    yield put(actions.admin.getGroups());
    yield put(actions.firm.addFirmToOrganizationSuccess());
    toast.success('Firm updated.');
  } catch (e) {
    yield put(actions.firm.addFirmToOrganizationFail(e.message));
    toast.error(
      'An error occurred updating the firm.  Make sure you did not rename the firm to a name that is already in use.'
    );
  } finally {
    yield put(actions.user.setLoading(false));
  }
}
export function* removeFirmFromOrganization({ payload: { firmId } }) {
  try {
    yield put(actions.user.setLoading(true));
    yield call(showcaseApi.addFirmToOrganization, { firmId, userGroupId: null });
    yield put(actions.admin.getGroups());
    yield put(actions.firm.removeFirmFromOrganizationSuccess());
    toast.success('Firm updated.');
  } catch (e) {
    yield put(actions.firm.removeFirmFromOrganizationFail(e.message));
    toast.error(
      'An error occurred updating the firm.  Make sure you did not rename the firm to a name that is already in use.'
    );
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* searchFirms({ payload: { query } }) {
  try {
    yield put(actions.user.setLoading(true));
    const firms = yield call(showcaseApi.searchFirms, query);
    yield put(actions.firm.searchFirmsSuccess(firms));
  } catch (e) {
    yield put(actions.firm.searchFirmsSuccess(e.message));
    toast.error('An error occurred searching firms.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* firmSagas() {
  yield takeEvery(actions.firm.getFirms, getFirms);
  yield takeEvery(actions.firm.getFirmsForLookup, getFirmsForLookup);
  yield takeEvery(actions.firm.getFirmById, getFirmById);
  yield takeEvery(actions.firm.updateFirm, updateFirm);
  yield takeEvery(actions.firm.addFirm, addFirm);
  yield takeEvery(actions.firm.searchFirms, searchFirms);
  yield takeEvery(actions.firm.addFirmToOrganization, addFirmToOrganization);
  yield takeEvery(actions.firm.removeFirmFromOrganization, removeFirmFromOrganization);
}
